export default __webpack_public_path__ + "static/media/westfalen_logo.2cef8fb3.svg";